import React from "react"

type BagProps = {
  className?: string
}

export function Bag(props: BagProps) {
  const { className = "" } = props
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.3733 5.52413C16.369 5.41576 16.3235 5.3131 16.2461 5.23719C16.1686 5.16127 16.0651 5.11785 15.9566 5.1158H12.8983C12.8372 4.56483 12.652 4.03488 12.3566 3.5658C12.1066 3.17111 11.7569 2.84929 11.3429 2.63276C10.9289 2.41624 10.4651 2.31266 9.99828 2.33247C9.53147 2.31266 9.06769 2.41624 8.65366 2.63276C8.23963 2.84929 7.88998 3.17111 7.63995 3.5658C7.34454 4.03488 7.15935 4.56483 7.09828 5.1158H4.03995C3.9315 5.11785 3.82795 5.16127 3.75049 5.23719C3.67302 5.3131 3.62751 5.41576 3.62328 5.52413L3.16495 17.1908C3.16129 17.2468 3.169 17.303 3.18762 17.356C3.20624 17.409 3.23537 17.4577 3.27328 17.4991C3.35721 17.5773 3.46697 17.6218 3.58161 17.6241H16.4149C16.5276 17.6239 16.6355 17.5789 16.7149 17.4991C16.7552 17.459 16.7864 17.4107 16.8065 17.3575C16.8266 17.3044 16.8352 17.2475 16.8316 17.1908L16.3733 5.52413ZM7.93995 5.1158C7.99288 4.72856 8.1263 4.3567 8.33161 4.02413C8.51022 3.74957 8.75881 3.52761 9.05178 3.38113C9.34474 3.23465 9.67147 3.16895 9.99828 3.1908C10.3251 3.16895 10.6518 3.23465 10.9448 3.38113C11.2377 3.52761 11.4863 3.74957 11.6649 4.02413C11.8732 4.35603 12.0095 4.72793 12.0649 5.1158H7.93995ZM4.01495 16.7825L4.43995 5.94913H15.5566L15.9816 16.7825H4.01495Z"
        fill="currentColor"
      />
    </svg>
  )
}
